import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { AiOutlineRight } from "react-icons/ai";
import docx from "../../common/images/IconsPNG/docx-icon.png";
import pdf from "../../common/images/IconsPNG/pdf-icon.png";
import ppt from "../../common/images/IconsPNG/ppt-icon.png";
import xl from "../../common/images/IconsPNG/xl-icon.png";
import doc from "../../common/images/IconsPNG/doc-icon.png";
import { getUserNavigationConfrimPopup } from "../../redux/actions/commonAction";
import "../../styles/artefact.styles.scss";
import { serverUrl } from "../../components/Helpers/Config";
import { trimString, tokenAuthorize } from "../../components/Helpers/Common";
import { FaTrashAlt } from "react-icons/fa";
import { getArteFiles } from "../../redux/actions/artefact";
import Swal from "sweetalert2";
import { ActiveIconColor } from "../Theme";
import NavTabs from "../../components/Navbar/NavTabs";

function Artefacts() {
  const dispatch = useDispatch();
  const files = useSelector((state) => state.arteFiles.files);
  const [showImage, setShowImage] = useState(true);
  const [showDoc, setShowDoc] = useState(false);
  const [searchField, setSearchField] = useState("");

  let filteredDocs = [],
    filteredImages = [];

  try {
    filteredDocs = files.filter((file) => file.file_id !== "");
    filteredImages = files.filter((file) => file.file_id === "");
  } catch (error) {}

  const totalArtefacts = filteredDocs.length + filteredImages.length;

  function images() {
    setShowImage(!showImage);
  }

  function documents() {
    setShowDoc(!showDoc);
  }

  useEffect(() => {
    dispatch(getUserNavigationConfrimPopup(false));
    dispatch(getArteFiles());
  }, []);

  const handleDelete = (e, fileId, details) => {
    e.preventDefault();
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      html:
        "This artefact is attached to post <b>" +
        details.reflection_title +
        "</b>. Are you sure to delete this file?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${serverUrl.Artefacts}/${fileId}`)
          .then(() => {
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "File has been deleted",
              icon: "success",
            });
            dispatch(getArteFiles());
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            Swal.fire({
              heightAuto: false,
              title: "Error",
              text: "Cannot delete the file",
              icon: "error",
            });
          });
      }
    });
  };

  const Showed = ({ active, text, length }) => {
    let style = active ? "rotate-90" : "rotate-0";
    style += " transform";
    return (
      <div className="w-full flex items-center my-5">
        <div
          className="flex pr-3 cursor-pointer"
          onClick={
            text === "Images" ? images : text === "Documents" ? documents : ""
          }
        >
          <div className="w-max flex items-center">
            <AiOutlineRight className={style} /> {text} ({length})
          </div>
        </div>
        <div className="w-full border h-0" />
      </div>
    );
  };

  const GetMore = ({ active, does }) => {
    let style = active ? "inline-block" : "hidden";
    style += " w-max  underline text-gray-400 cursor-pointer";
    return (
      <div className="mt-6 pb-6 w-full flex justify-center">
        {false && (
          <div className={style} onClick={does}>
            load more items...
          </div>
        )}
      </div>
    );
  };

  const DocType = ({ type }) => {
    let file =
      type === "docx"
        ? docx
        : type === "pdf"
        ? pdf
        : type === "xlsx"
        ? xl
        : type === "ppt"
        ? ppt
        : doc;
    return <img src={file} className="w-32 h-32" alt="docimg" />;
  };

  return (
    <div className="w-full px-6 lg:px-8 pt-4 pb-3">
      {/* <div className='flex flex-col-reverse lg:flex-row items-center justify-between'>
                <div className='flex flex-col md:flex-row md:items-center md:space-x-6 md:w-full'>
                    <div
                        className='flex items-center whitespace-nowrap text-sm md:text-base justify-around md:justify-center 
                                    lg:justify-start gap-2 md:gap-6'
                    >
                        <div className='w-max'>
                            Showing {totalArtefacts} of {totalArtefacts} items
                        </div>
                    </div>
                </div>
            </div> */}
      <div className="w-full mb-6">
        <NavTabs
          menuLinks={[
            {
              title: "Images",
              index: "Images",
              onChange: (e) => {
                setShowImage(true);
                setShowDoc(false);
              },
            },
            {
              title: "Documents",
              index: "Documents",
              onChange: (e) => {
                setShowImage(false);
                setShowDoc(true);
              },
            },
          ]}
          value={showImage ? "Images" : "Documents"}
          padding={false}
          isDot={false}
        />
      </div>
      <div className="mb-10">
        {/* <Showed active={showImage} text={'Images'} length={filteredImages.length} /> */}
        {showImage ? (
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4  xl:grid-cols-5 gap-7 md:gap-6">
              {filteredImages &&
                filteredImages.map((item, idx) => (
                  <div
                    className="slot1 relative shadow-md border20px "
                    key={idx}
                  >
                    <ActiveIconColor
                      className="absolute right-5 top-5 w-7 h-7 cursor-pointer z-10 border border-gray-400 flex align-center justify-center items-center rounded-md bg-gray-100 hover:bg-gray-200"
                      onClick={(e) =>
                        handleDelete(e, item.reflection_file_id, item)
                      }
                    >
                      <FaTrashAlt className=" deleteColor" />
                    </ActiveIconColor>
                    <a
                      href={encodeURI(item.file_url)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="square"
                    >
                      <img
                        src={encodeURI(item.file_url)}
                        alt=""
                        className="rounded-lg border20px  border"
                      />
                    </a>
                  </div>
                ))}
            </div>
            {/* <GetMore active={props.hasmore} does={props.addArteImagesPage} /> */}
          </div>
        ) : null}
        {/* <Showed active={showDoc} text={'Documents'} length={filteredDocs.length} /> */}
        {showDoc ? (
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-5 md:gap-7">
              {filteredDocs &&
                filteredDocs.map((item, idx) => {
                  let itemName = item.file_url;
                  if (itemName) {
                    const lastSlash = itemName.lastIndexOf("/");

                    if (lastSlash !== -1) {
                      itemName = itemName.substr(
                        lastSlash + 1,
                        itemName.length - lastSlash - 1
                      );
                      itemName = itemName.includes("-")
                        ? itemName.substring(itemName.indexOf("-") + 1)
                        : itemName;
                    }
                    return (
                      <div
                        key={idx}
                        className="slot1 flex relative shadow-md border20px"
                      >
                        <ActiveIconColor
                          className="absolute right-5 top-5 w-7 h-7 cursor-pointer z-10 border border-gray-400  flex align-center justify-center items-center rounded-md "
                          onClick={(e) =>
                            handleDelete(e, item.reflection_file_id, item)
                          }
                        >
                          <FaTrashAlt className="deleteColor" />
                        </ActiveIconColor>
                        <a
                          href={item.file_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className=" focus:outline-none px-3 py-5 w-full rounded-lg bg-white hover:outline-none outline-none flex flex-col items-center justify-center border border20px no-underline hover:no-underline"
                        >
                          <DocType type={item.file_url.split(".").pop()} />
                          <p className="break-words blueColor focus:outline-none w-full text-md md:text-sm md:w-full mt-5 text-center hover:outline-none outline-none ">
                            {trimString(itemName, 72)}
                          </p>
                        </a>
                      </div>
                    );
                  }

                  return null;
                })}
            </div>
            {/* <GetMore active={props.hasmore2} does={props.addArteDocsPage} /> */}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Artefacts;
